module.exports = __webpack_public_path__ + "rocket.a89a048eaa7412c26a872ae1374a5134.png";